<template>
  <accounts-component-template
    :component-name="'Acclaro Team (' + team.length + ')'"
    component-key="acclaro-users"
    color="#EF731A"
    :has-search="false">
    <template v-slot:icon>
      <account-group-outline-icon :size="16"/>
    </template>
    <template v-slot:content>
      <div class="acclaro-team-component-content">
        <table>
          <thead>
            <tr>
              <th class="text-align-left" @click="updateSort">Name</th>
              <th class="text-align-left">Title</th>
              <th>Visible to Client</th>
              <th>Gets Account Notifications</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in team">
              <td>
                <div>{{user.lastname}}, {{user.firstname}}</div> 
                <div class="invalid-resource" v-if="!isResource(user)">Invalid resource</div>
              </td>
              <td>
                  <multiselect
                      placeholder="Type title and press enter to select"
                      tag-placeholder="Press enter to add Title"
                      class="co-custom-arrow"
                      :value="user.title"
                      :options="teamTitles"
                      :multiple="false"
                      :taggable="true"
                      :deselect-label="' '"
                      :allow-empty="false"
                      @input="(title) => updateTitle(user.team_id, title)"
                      @tag="(title) => onTitle(user.team_id, title)">
                      <span slot="noResult">No results found</span>
                      <template slot="caret" slot-scope="{toggle}" :toggle="toggle">
                          <chevron-down-icon title="titles" :size="24" @mousedown.prevent.stop="toggle()" class="multiselect__select" />
                      </template>
                  </multiselect>
              </td>
              <td class="text-align-center">
                <input type="checkbox" :checked="user.visible == 1" :value="user.visible" @change="updateVisibility(user.team_id, $event.target.checked)" />
              </td>
              <td class="text-align-center">
                <input type="checkbox" :checked="user.notify == 1" :value="user.notify" @input="updateNotify(user.team_id, $event.target.checked)" />
              </td>
              <td>
                  <CloseIcon @click="deleteTeam(user.team_id)" :size="20" :fillColor="'#333'" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <footer class="acclaro-team-component-footer">
        <button @click="showAddTeamMemberDialog" class="add-team-member-btn">
            <PlusCircleIcon :size="20" :fillColor="'#0069AA'" />
            <span>Add Team Member</span>
        </button>
      </footer>  
    </template>
  </accounts-component-template>
</template>

<script>
import AccountsComponentTemplate from './AccountsComponentTemplate.vue';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import {AccountGroupOutlineIcon, PlusCircleIcon, CloseIcon} from '../icons';
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {

	props: {},

	components: {
		AccountsComponentTemplate,
		AccountGroupOutlineIcon,
        PlusCircleIcon,
        ChevronDownIcon,
        CloseIcon,
	},

	data() {
		return {}
	},

    updated() {
        console.log('teams', this.team)

    },

    mounted () {
      this.getResources().then(resources => {
        console.log('the resources', resources);
      })
    },

    computed: {

        ...mapGetters('AdminAccountDetailsTeamStore', [
            'sortedTeams',
            'teamTitles',
            'resources',
        ]),

        team () {
            return this.sortedTeams || [];
        }
    },

	methods: {

		...mapActions('AdminAccountDetailsTeamStore', {
			callSort: 'sort',
			callUpdateNotify: 'updateNotify',
      callUpdateVisibility: 'updateVisibility',
			callUpdateTitle: 'updateTitle',
			callDelete: 'delete',
			callUpdateName: 'updateName',
            callUpdateTitle: 'updateTitle',
            getResources: 'getResources',
		}),

        onTitle (teamId, title) {
          this.callUpdateTitle({
              teamId,
              title,
          }).then(data => {
              if(!data) {
                  console.error('update title error')
              }
          })
        },

        /**
         * check if a team member is a resource
         *
         */
        isResource (member) {
            if (!this.resources) return false;
            
            return (this.resources.findIndex(resource => resource.id == member.user )) >= 0;
        },

        /**
         * Update the team members visibility
         *
         */
        updateVisibility(teamId, visible) {
            this.callUpdateVisibility({
                teamId,
                visible
            }).then(data => {
                if (!data) {
                    console.error('update visibility error')
                }
            })
        },


        /**
         * add a team member
         *
         */
        showAddTeamMemberDialog (result, user) {
          this.$emit('team-member-modal');
        },

        /**
         * Update the sort order of teams.
         *
         * @param {Object} payload
         */
        updateSort() {
            this.callSort();
        },

        /**
         * Update the notify setting of a team member
         *
         * @param {Number} userId
         * @param {Boolean} notify
         */
        updateNotify(teamId, notify) {
            this.callUpdateNotify({
                teamId,
                notify,
            }).then(data => {
                if (!data) {
                    return console.error('update notification error')
                }
            })
        },

        /**
         * Update the title of a team member
         *
         * @param {Number} userId
         * @param {String} title
         */
        updateTitle(teamId, title) {
            this.callUpdateTitle({
                teamId,
                title,
            }).then(result => {
                if(!result) {
                    console.error('update title error');
                }
            })
        },

        /**
         * Delete a team member
         *
         * @param {Number} teamId
         */
        deleteTeam(team_id) {
            this.callDelete({
                team_id,
            })
            .then(result => {
                
            })
            .catch(error => {
                console.error('failed to delete team member', error);
            })
        },

        /**
         * Update a team members name
         *
         * @param {Number} id
         * @param {String} name
         */
        updateName(userId, name) {
            this.callUpdateName({
                userId,
                name,
            }).then(result => {
                if(!result) {
                    return console.error('update name error')
                }
            })
        },
	}
}
</script>
